
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>素材署名与许可信息</h1>
<p>本角色生成器使用了来自 Liberated Pixel Cup (LPC) 项目的开放艺术素材。这些素材由众多艺术家创作和贡献，并遵循不同的开源许可协议发布。我们对所有创作者的辛勤工作表示衷心感谢。</p>
<p>主要精灵图作者包括（但不限于）：
Johannes Sjölund（wulax）、Michael Whitlock（bigbeargames）、Matthew Krohn（makrohn）、Nila122、David Conway Jr.（JaidynReiman）、Carlo Enrico Victoria（Nemisys）、Thane Brimhall（pennomi）、bluecarrot16、Luke Mehl、Benjamin K. Smith（BenCreating）、ElizaWy、MuffinElZangano、Durrani、kheftel、Stephen Challener（Redshrike）、TheraHedwig、Evert、Pierre Vigier（pvigier）、Eliza Wyatt（ElizaWy）、Johannes Sj?lund（wulax）、Sander Frenken（castelonia）、dalonedrau、Lanea Zimmerman（Sharm）等。​</p>
<h2>详细署名与许可信息：</h2>
<p>要查看本生成器所使用的每一项具体素材的作者、来源链接以及其对应的许可协议（包括 CC0, CC-BY, CC-BY-SA 4.0, OGA-BY, GPL 3.0 等），请参考以下详细列表</p>
<p>请访问: <code class="">https://raw.githubusercontent.com/LiberatedPixelCup/Universal-LPC-Spritesheet-Character-Generator/refs/heads/master/CREDITS.csv</code></p>
</div>
</template>
